export default "__VITE_ASSET__DkRclPhk__"